import { render, staticRenderFns } from "./BacktestMACD.vue?vue&type=template&id=ba02c1ec&scoped=true"
import script from "./BacktestMACD.vue?vue&type=script&lang=js"
export * from "./BacktestMACD.vue?vue&type=script&lang=js"
import style0 from "./BacktestMACD.vue?vue&type=style&index=0&id=ba02c1ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba02c1ec",
  null
  
)

export default component.exports